import React from 'react'
import { Card, Descriptions, Button, Alert } from 'antd'
import { useTranslation } from 'react-i18next'
import { localeService } from '../../services/localeService'
import { UserResponse } from '../../types/user'

interface ProfileInfoProps {
    user: UserResponse | null
    error: string | null
    success: string | null
    loading: boolean
    onClearSuccess: () => void
    onClearError: () => void
    onShowPasswordModal: () => void
}

export const ProfileInfo: React.FC<ProfileInfoProps> = ({
    user,
    error,
    success,
    onClearSuccess,
    onClearError,
    onShowPasswordModal,
}) => {
    const { t } = useTranslation('profile')
    const hasAdminPrivilege = user?.is_superuser || user?.role === 'admin'
    
    return (
        <Card>
            {success && (
                <Alert
                    message={success}
                    type="success"
                    showIcon
                    closable
                    onClose={onClearSuccess}
                    style={{ marginBottom: 24 }}
                />
            )}

            {error && (
                <Alert
                    message={error}
                    type="error"
                    showIcon
                    closable
                    onClose={onClearError}
                    style={{ marginBottom: 24 }}
                />
            )}

            {user && (
                <>
                    <Descriptions column={1} bordered>
                        <Descriptions.Item label={t('basic.userId')}>
                            {user.id}
                        </Descriptions.Item>
                        <Descriptions.Item label={t('basic.username')}>
                            {user.username}
                        </Descriptions.Item>
                        <Descriptions.Item label={t('basic.registeredAt')}>
                            {localeService.formatDate(user.created_at)}
                        </Descriptions.Item>
                        <Descriptions.Item label={t('basic.accountStatus')}>
                            {user.is_active ? t('basic.active') : t('basic.inactive')}
                        </Descriptions.Item>
                        <Descriptions.Item label={t('basic.adminPrivilege')}>
                            {hasAdminPrivilege ? t('basic.yes') : t('basic.no')}
                        </Descriptions.Item>
                    </Descriptions>

                    <div style={{ marginTop: 24 }}>
                        <Button type="primary" onClick={onShowPasswordModal}>
                            {t('security.changePassword')}
                        </Button>
                    </div>
                </>
            )}
        </Card>
    )
}
